<script setup>
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import {
  Empty,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
  EmptyDescription,
} from 'next/polaris/ui/empty';

const { t } = useI18n();
const uiFlags = useMapGetter('notifications/getUIFlags');
</script>

<template>
  <div class="hidden h-full w-full min-w-0 bg-n-surface-1 lg:flex">
    <div
      v-if="uiFlags.isFetching"
      class="flex w-full items-center justify-center"
    >
      <Spinner class="text-n-brand" />
    </div>
    <Empty v-else class="h-full">
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <Icon icon="i-lucide-bell" class="size-6" />
        </EmptyMedia>
        <EmptyTitle>{{ t('INBOX.LIST.SELECT_NOTIFICATION') }}</EmptyTitle>
        <EmptyDescription>{{ t('INBOX.LIST.NOTE') }}</EmptyDescription>
      </EmptyHeader>
    </Empty>
  </div>
</template>
